import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomTextField from "../../../components/customFields/CustomTextField";
import CustomSelectField from "../../../components/customFields/CustomSelectField";
import {
  editUserAddress,
  getCityByState,
  getCountries,
  getStateByCountry,
  saveUserAddress,
} from "../../testPrepDashboard/Api/DashboardApi";
import PinkExtraSmallButton from "../../../components/customButtons/PinkExtraSmallButton";
import CustomPopup from "../../../components/customPopup/CustomPopup";
import ErrorPopup from "../../../components/customPopup/ErrorPopup";
import { useLocation } from "react-router-dom";
import ErrorPopupScreen from "../../../components/customPopup/ErrorPopupScreen";

export default function EditUserAddress({
  handleClose,
  handleOpenSuccessPopup,
  selectedData,
  setSuccessTitle,
}) {
  const userId = localStorage.getItem("userId");
  const location = useLocation();
  const firstName = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");
  const [changes, setChanges] = useState({});
  const [userFullName, setUserFullName] = useState(firstName + " " + lastName);
  const [selectedCountry, setSelectedCountry] = useState(
    selectedData?.country?.id || 101
  );
  const [stateId, setStateId] = useState(selectedData?.state?.id || null);
  const [cityId, setCityId] = useState(selectedData?.city?.id || null);
  const [zipCode, setZipcode] = useState(selectedData?.zip_code || null);
  const [streetAddress, setStreetAddress] = useState(
    selectedData?.address || null
  );

  //   const [billingData, setBillingData] = useState({
  //     fullName: firstName,
  //     selectedCountry: selectedData?.country?.id || 101,
  //     stateId: selectedData?.state?.id,
  //     cityId: selectedData?.city?.id,
  //     zipCode: selectedData?.zip_code,
  //     streetAddress: selectedData?.address,
  //   });

  const [checked, setChecked] = React.useState(selectedData?.is_default);
  const [countryList, setCountryList] = useState([]);

  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonTitle, setButtonTitle] = useState(null);

  const [errors, setErrors] = useState({});

  const handleFieldChange = (fieldName, value) => {
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));
    // setValue(fieldName, value); // Update form value
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCountries();
        setCountryList(data);
      } catch (err) {
        console.error("Could not fetch country");
        setCountryList([]);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getStateByCountry(selectedCountry);
        setStateList(data?.data);
      } catch (err) {
        console.error("Could not fetch State");
        setStateList([]);
      }
    };

    fetchData();
  }, [selectedCountry]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCityByState(stateId);
        setCityList(data?.data);
      } catch (err) {
        console.error("Could not fetch State");
        setCityList([]);
      }
    };

    fetchData();
  }, [stateId]);

  const validateBilling = () => {
    const newErrors = {};

    if (!userFullName?.trim()) newErrors.fullName = "Full name is required";
    if (!selectedCountry) newErrors.selectedCountry = "Country is required";
    if (!stateId) newErrors.stateId = "State is required";
    if (!cityId) newErrors.cityId = "City is required";
    if (!zipCode?.trim()) newErrors.zipCode = "Zip code is required";
    if (!streetAddress?.trim())
      newErrors.streetAddress = "Street address is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
    handleFieldChange("is_default", event.target.checked);
  };

  const handleSaveAddress = async () => {
    if (validateBilling()) {
      try {
        const response = await editUserAddress({
          ...changes,
          id: selectedData?.id,
          user_id: parseInt(userId),
        });

        if (response.statusCode === 200) {
          handleClose();
          handleOpenSuccessPopup();
          setSuccessTitle("Address Updated Successfully !!");
        } else if (response.statusCode === 400) {
          setErrorMessage(response.message);
          handleOpenErrorPopup();
          setButtonTitle("Got It");
        } else if (response.statusCode === 404) {
          setErrorMessage(response.message);
          handleOpenErrorPopup();
          setButtonTitle("Try Again");
        } else if (response.statusCode === 500) {
          setErrorMessage(response.message);
          handleOpenErrorPopup();
          setButtonTitle("Try Again");
        } else {
          setErrorMessage("Internal Server Error");
          handleOpenErrorPopup();
          setButtonTitle("Try Again");
        }
      } catch (error) {
        setErrorMessage("Internal Server Error");
        handleOpenErrorPopup();
        setButtonTitle("Try Again");
      }
    } else {
      console.log("Not saved address");
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#572575"
            fontFamily="Inter"
            fontSize="20px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 400 }}
          >
            Billing Address
          </Typography>
        </Grid>

        <Grid item xs={12} mt={1}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Full Name <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomTextField
            value={userFullName}
            onChange={(e) => {
              setUserFullName(e.target.value);
              handleFieldChange("name", e.target.value);
            }}
            error={!!errors.fullName}
            helperText={errors.fullName}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="Enter Your Name"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Country <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomSelectField
            options={countryList}
            getOptionLabel={(opt) => opt?.country_name}
            getOptionValue={(opt) => opt?.id}
            value={selectedCountry}
            onChange={(e) => {
              setSelectedCountry(e.target.value);

              handleFieldChange("country_id", e.target.value);
            }}
            error={!!errors.selectedCountry}
            helperText={errors.selectedCountry}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="select"
            dafualtValue="Select Country"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            State / Union Territory <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomSelectField
            options={
              selectedCountry === null && stateList?.length === 0
                ? [
                    {
                      id: "",
                      state_name: "Please select country first",
                      disabled: true,
                    },
                  ]
                : selectedCountry !== null && stateList?.length === 0
                ? [{ id: "", state_name: "No state available", disabled: true }]
                : stateList
            }
            getOptionLabel={(opt) => opt?.state_name}
            getOptionValue={(opt) => opt?.id}
            value={stateId}
            onChange={(e) => {
              setStateId(e.target.value);
              handleFieldChange("state_id", e.target.value);
            }}
            error={!!errors.stateId}
            helperText={errors.stateId}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="select"
            dafualtValue="Select State"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            City <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomSelectField
            options={
              stateId === null && cityList?.length === 0
                ? [
                    {
                      id: "",
                      city_name: "Please select state first",
                      disabled: true,
                    },
                  ]
                : stateId !== null && cityList?.length === 0
                ? [{ id: "", city_name: "No city available", disabled: true }]
                : cityList
            }
            getOptionLabel={(opt) => opt?.city_name}
            getOptionValue={(opt) => opt?.id}
            value={cityId}
            onChange={(e) => {
              setCityId(e.target.value);
              handleFieldChange("city_id", e.target.value);
            }}
            error={!!errors.cityId}
            helperText={errors.cityId}
            fullWidth
            borderColor="#DDDDDD"
            dafualtValue="Select City"
          />
        </Grid>

        <Grid item xs={12} mt={1}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Zip / Postal Code <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomTextField
            type="number"
            value={zipCode}
            onChange={(e) => {
              setZipcode(e.target.value);
              handleFieldChange("zip_code", e.target.value);
            }}
            error={!!errors.zipCode}
            helperText={errors.zipCode}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="Enter Zip Code"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Street Address (Include landmark)
            <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomTextField
            value={streetAddress}
            onChange={(e) => {
              setStreetAddress(e.target.value);
              handleFieldChange("address", e.target.value);
            }}
            error={!!errors.streetAddress}
            helperText={errors.streetAddress}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="Enter Your Address"
          />
        </Grid>

        <Grid item xs={12} sm={6} textAlign="start">
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  disabled={selectedData?.is_default === true}
                  onChange={handleChange}
                  sx={{
                    "&.Mui-checked": {
                      color: "#572575",
                    },
                  }}
                />
              }
              label="Set as default address"
              sx={{
                "& .MuiFormControlLabel-label": {
                  color: "#572575",
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "14px",
                },
              }}
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} sm={6} textAlign="end">
          <PinkExtraSmallButton
            buttonTitle="Save Address"
            onClick={handleSaveAddress}
          />
        </Grid>
      </Grid>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle={buttonTitle}
        // startIcon={<ArticleIcon />}
        navigateLink="/test-prep/checkout"
        currentPathname={location.pathname}
        maxWidth="xs"
      />
    </>
  );
}
